export const ACTIONS_OPERATOR = {
  INVALIDATE: 'OPERATORS_INVALIDATE',
  RECEIVE: 'OPERATORS_RECEIVE',
  DELETE: 'OPERATOR_DELETE',
  UPDATE: 'OPERATOR_UPDATE',
};

const operatorConstants = {};

export default operatorConstants;
